// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"GrayCircle_wrapper__3H09A"};